/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { TrackItMeasurementSoftwareDto } from './TrackItMeasurementSoftwareDto';
import {
    TrackItMeasurementSoftwareDtoFromJSON,
    TrackItMeasurementSoftwareDtoFromJSONTyped,
    TrackItMeasurementSoftwareDtoToJSON,
} from './TrackItMeasurementSoftwareDto';
import type { TrackItRadiationtUnitDto } from './TrackItRadiationtUnitDto';
import {
    TrackItRadiationtUnitDtoFromJSON,
    TrackItRadiationtUnitDtoFromJSONTyped,
    TrackItRadiationtUnitDtoToJSON,
} from './TrackItRadiationtUnitDto';
import type { TrackItMeasurementDeviceDto } from './TrackItMeasurementDeviceDto';
import {
    TrackItMeasurementDeviceDtoFromJSON,
    TrackItMeasurementDeviceDtoFromJSONTyped,
    TrackItMeasurementDeviceDtoToJSON,
} from './TrackItMeasurementDeviceDto';

/**
 * 
 * @export
 * @interface TrackItImportInfoDto
 */
export interface TrackItImportInfoDto {
    /**
     * 
     * @type {number}
     * @memberof TrackItImportInfoDto
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof TrackItImportInfoDto
     */
    title: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackItImportInfoDto
     */
    importDate: string;
    /**
     * 
     * @type {number}
     * @memberof TrackItImportInfoDto
     */
    measurementCount: number;
    /**
     * 
     * @type {Array<TrackItRadiationtUnitDto>}
     * @memberof TrackItImportInfoDto
     */
    radiationUnits: Array<TrackItRadiationtUnitDto> | null;
    /**
     * 
     * @type {Array<TrackItMeasurementDeviceDto>}
     * @memberof TrackItImportInfoDto
     */
    measurementDevices: Array<TrackItMeasurementDeviceDto> | null;
    /**
     * 
     * @type {Array<TrackItMeasurementSoftwareDto>}
     * @memberof TrackItImportInfoDto
     */
    measurementSoftwares: Array<TrackItMeasurementSoftwareDto> | null;
    /**
     * 
     * @type {string}
     * @memberof TrackItImportInfoDto
     */
    $type?: TrackItImportInfoDtoTypeEnum;
}


/**
 * @export
 */
export const TrackItImportInfoDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTrackItImportComponentDtoTrackItImportInfoDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItImportInfoDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type TrackItImportInfoDtoTypeEnum = typeof TrackItImportInfoDtoTypeEnum[keyof typeof TrackItImportInfoDtoTypeEnum];



/**
 * Check if a given object implements the TrackItImportInfoDto interface.
 */
export function instanceOfTrackItImportInfoDto(value?: unknown): value is TrackItImportInfoDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(TrackItImportInfoDtoTypeEnum)[0];
}

export function TrackItImportInfoDtoFromJSON(json: any): TrackItImportInfoDto {
    return TrackItImportInfoDtoFromJSONTyped(json, false);
}

export function TrackItImportInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackItImportInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': json['title'],
        'importDate': json['importDate'],
        'measurementCount': json['measurementCount'],
        'radiationUnits': (json['radiationUnits'] == null ? null : (json['radiationUnits'] as Array<any>).map(TrackItRadiationtUnitDtoFromJSON)),
        'measurementDevices': (json['measurementDevices'] == null ? null : (json['measurementDevices'] as Array<any>).map(TrackItMeasurementDeviceDtoFromJSON)),
        'measurementSoftwares': (json['measurementSoftwares'] == null ? null : (json['measurementSoftwares'] as Array<any>).map(TrackItMeasurementSoftwareDtoFromJSON)),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function TrackItImportInfoDtoToJSON(value?: TrackItImportInfoDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'title': value['title'],
        'importDate': value['importDate'],
        'measurementCount': value['measurementCount'],
        'radiationUnits': (value['radiationUnits'] == null ? null : (value['radiationUnits'] as Array<any>).map(TrackItRadiationtUnitDtoToJSON)),
        'measurementDevices': (value['measurementDevices'] == null ? null : (value['measurementDevices'] as Array<any>).map(TrackItMeasurementDeviceDtoToJSON)),
        'measurementSoftwares': (value['measurementSoftwares'] == null ? null : (value['measurementSoftwares'] as Array<any>).map(TrackItMeasurementSoftwareDtoToJSON)),
        '$type': value['$type'],
    });
}

